"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BN_THOUSAND = exports.BN_HUNDRED = exports.BN_TEN = exports.BN_ONE = exports.BN_ZERO = void 0;

var _bn = _interopRequireDefault(require("bn.js"));

// Copyright 2017-2020 @polkadot/util authors & contributors
// This software may be modified and distributed under the terms
// of the Apache-2.0 license. See the LICENSE file for details.

/**
 * @name BN_ZERO
 * @summary BN constant for 0.
 */
const BN_ZERO = new _bn.default(0);
/**
 * @name BN_ONE
 * @summary BN constant for 1.
 */

exports.BN_ZERO = BN_ZERO;
const BN_ONE = new _bn.default(1);
/**
 * @name BN_TEN
 * @summary BN constant for 10.
 */

exports.BN_ONE = BN_ONE;
const BN_TEN = new _bn.default(10);
/**
 * @name BN_HUNDRED
 * @summary BN constant for 100.
 */

exports.BN_TEN = BN_TEN;
const BN_HUNDRED = new _bn.default(100);
/**
 * @name BN_THOUSAND
 * @summary BN constant for 1000.
 */

exports.BN_HUNDRED = BN_HUNDRED;
const BN_THOUSAND = new _bn.default(1000);
exports.BN_THOUSAND = BN_THOUSAND;